import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import GtmService from 'static/script/app/ui/google-tagmanager-service';
import { useUrlLocalizer } from 'tradera-lang';
import useIsDesktop from 'tradera-hooks/use-is-desktop';

const Tag = ({ color, gaAction, gaCategory, name, onClick, url }) => {
    const { toLocalizedUrl } = useUrlLocalizer();
    const isDesktop = useIsDesktop();
    return (
        <Link
            type="button"
            className={`btn ${
                isDesktop ? 'btn-sm' : ''
            } btn-${color} mx-2 my-2 px-3`}
            onClick={() => {
                typeof onClick === 'function' && onClick();
                GtmService.trackAction(gaCategory, gaAction, name);
            }}
            to={toLocalizedUrl(url)}>
            {name}
        </Link>
    );
};

Tag.defaultProps = {
    color: 'secondary',
    gaAction: 'Navigation',
    gaCategory: 'Search'
};

Tag.propTypes = {
    color: PropTypes.string,
    name: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    gaAction: PropTypes.string,
    gaCategory: PropTypes.string,
    url: PropTypes.string.isRequired
};

export default Tag;
